import Records from "./Records";

export default Records;
